import { useIsTicketWritable } from 'hooks/tickets'
import { selectCurrentUser, selectTicket } from 'redux/appStore'
import { useSelector } from 'react-redux'
import { useServiceProxy } from '../kong'

export default function useCreateEhiTicketNote() {
  const { ticketNumber, pickupInfo } = useSelector(selectTicket)
  const currentUser = useSelector(selectCurrentUser)

  const isWritable = useIsTicketWritable()
  const serviceProxy = useServiceProxy()

  async function postEhiTicketNote(comment: string) {
    await serviceProxy(
      'POST',
      `/serviceproxy/ticket/${ticketNumber}/note`,
      {
        // pass the brand as a header for RSA reporting in Splunk - mainly for Connected Car notes
        'Ehi-brand': pickupInfo.branch.brand,
      },
      comment,
    )
  }

  return async function createNote(text: string) {
    try {
      if (isWritable) {
        const notesWithoutNewlines = text.replace(/\r?\n|\r/g, ' ')

        //Split notes by word into 400 character chunks, 398 includes leading and trailing whitespace
        let splitNotes = notesWithoutNewlines.match(/\S.(.|[\r\n]){0,398}(?<=\S)(?!\S)/g)

        if (splitNotes && splitNotes.length > 1) {
          splitNotes?.forEach((comment) => {
            const body = JSON.stringify({
              createdUserId: currentUser!.nameID,
              text: comment,
            })
            postEhiTicketNote(body)
          })
        } else {
          const body = JSON.stringify({
            createdUserId: currentUser!.nameID,
            text: notesWithoutNewlines,
          })
          postEhiTicketNote(body)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
}
